import {ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {StepOneComponent} from '../../views/wrapper/payroll/payroll-step/step-one/step-one.component';
import {LeavePageConfirmModalComponent} from '../../shared/components/leave-page-confirm-modal/leave-page-confirm-modal.component';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PageGuardService implements CanDeactivate<ComponentCanDeactivate> {

  modalRef: BsModalRef;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    public stepOne: StepOneComponent
  ) {
  }

  canDeactivate(component: ComponentCanDeactivate,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState: RouterStateSnapshot): boolean | Observable<boolean> {
    if (component instanceof StepOneComponent) {
      this.stepOne = component;
    }
    return component.canDeactivate() ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      this.openConfirmDialog(nextState);
  }

  openConfirmDialog(nextState) {
    this.modalRef = this.modalService.show(LeavePageConfirmModalComponent, {backdrop: 'static', class: 'custom-modal'});
    return this.modalRef.content.onClose.subscribe(result => {
      if (!result) { // case: cancel (Don't save)
        // if (this.stepOne.payrollStatus === PayrollStatus.init) {
        //   this.stepOne.confirmResetPayroll();
        // } else {
        this.stepOne.dontSave(nextState.url);
        // }
      } else { // case: save before leaving page
        this.stepOne.save(nextState.url);
      }
      return true;
    });
  }
}
